var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('ProfilePicture'),(_vm.propsReady)?_c('ProfileDetails',{attrs:{"productsData":_vm.data.ProductGroups,"userData":_vm.data.generalInfo}}):_vm._e(),(_vm.propsReady)?_c('ProfileLocations',{attrs:{"locationData":_vm.data.Locations}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }